// icons
import {
  MdDashboard,
  MdFlag,
  MdVisibility,
  MdTrackChanges,
  MdCalendarMonth,
  MdViewQuilt,
  MdDateRange,
  MdTask,
  MdDescription,
  MdFolder,
  MdAccountBalance,
  MdQuiz,
  MdAccountTree,
  MdPeople,
  MdTimeline,
  MdMenuBook
} from "react-icons/md";

const clientes = {
  id: 'clientes-group',
  type: 'group',
  roles: [200],
  breadcrumbs: false,
  children: [
    {
      id: 'clientes-dashboard',
      title: 'Dashboard',
      type: 'item',
      breadcrumbs: false,
      icon: MdDashboard,
      url: '/clientes/dashboard'
    },
    {
      id: 'clientes-plan-estrategico',
      title: 'Plan estratégico',
      type: 'collapse',
      icon: MdFlag,
      children: [
        {
          id: 'clientes-vision-estrategica',
          title: 'Visión estratégica',
          type: 'item',
          breadcrumbs: false,
          icon: MdVisibility,
          url: '/clientes/plan-estrategico/vision-estrategica'
        },
        // {
        //   id: 'clientes-objetivo-smart',
        //   title: 'Objetivo SMART',
        //   type: 'item',
        //   breadcrumbs: false,
        //   icon: MdTrackChanges,
        //   url: '/clientes/plan-estrategico/objetivo-smart'
        // },
        {
          id: 'clientes-cronograma',
          title: 'Cronograma',
          type: 'item',
          breadcrumbs: false,
          icon: MdCalendarMonth,
          url: '/clientes/plan-estrategico/cronograma'
        },
        {
          id: 'clientes-planificador-semanal',
          title: 'Planificador semanal',
          type: 'item',
          breadcrumbs: false,
          icon: MdDateRange,
          url: '/clientes/plan-estrategico/planificador-semanal'
        },
        {
          id: 'clientes-administrador-de-tareas',
          title: 'Administrador de tareas',
          type: 'item',
          breadcrumbs: false,
          icon: MdTask,
          url: '/clientes/plan-estrategico/administrador-de-tareas'
        },
      ]
    },
    
    {
      id: 'clientes-monitor-financiero',
      title: 'Monitor financiero',
      type: 'item',
      breadcrumbs: false,
      icon: MdAccountBalance,
      url: '/clientes/monitor-financiero'
    },
    {
      id: 'clientes-sistematizacion-estructura-organizacional',
      title: 'Sistematización y Estructura Organizacional',
      type: 'collapse',
      icon: MdAccountTree,
      children: [
        {
          id: 'clientes-analisis-de-estructura-organizacional',
          title: 'Análisis de Estructura Organizacional',
          type: 'item',
          breadcrumbs: false,
          icon: MdAccountTree,
          url: '/clientes/sistematizacion-estructura-organizacional/analisis-de-estructura-organizacional'
        },
        {
          id: 'clientes-analisis-de-procesos',
          title: 'Análisis de Procesos',
          type: 'item',
          breadcrumbs: false,
          icon: MdMenuBook,
          url: '/clientes/sistematizacion-estructura-organizacional/analisis-de-procesos'
        }
      ]
    },
    {
      id: 'clientes-repositorio-de-archivos',
      title: 'Repositorio de archivos',
      type: 'item',
      breadcrumbs: false,
      icon: MdFolder,
      url: '/clientes/repositorio-de-archivos'
    },
    // {
    //   id: 'clientes-requerimientos-de-informacion',
    //   title: 'Requerimientos de información',
    //   type: 'collapse',
    //   icon: MdDescription,
    //   children: [
    //     {
    //       id: 'clientes-diagnostico-360',
    //       title: 'Diagnóstico 360',
    //       type: 'item',
    //       breadcrumbs: false,
    //       icon: MdQuiz,
    //       url: '/clientes/requerimientos-de-informacion/diagnostico-360'
    //     },
    //     {
    //       id: 'clientes-procesos-de-la-empresa',
    //       title: 'Procesos de la empresa',
    //       type: 'item',
    //       breadcrumbs: false,
    //       icon: MdTimeline,
    //       url: '/clientes/requerimientos-de-informacion/procesos-de-la-empresa'
    //     },
    //     {
    //       id: 'clientes-organigrama-y-perfiles-de-puestos',
    //       title: 'Organigrama y perfiles de puestos',
    //       type: 'item',
    //       breadcrumbs: false,
    //       icon: MdPeople,
    //       url: '/clientes/requerimientos-de-informacion/organigrama-y-perfiles-de-puestos'
    //     }
    //   ]
    // }
  ]
};

export default clientes;